module.exports = __webpack_public_path__ + "img/img17.107edc89.svg";